export default {
    current_choice: 'Scelta attuale',
    book_now: 'Prenota ora',
    minimum_age: 'Solo per maggiori di {age} anni',
    excess_liability: 'Responsabilità eccedente',
    security_deposit: 'Deposito cauzionale',
    fuel_policy: 'Politica carburante',
    like_for_like: 'Come consegnato',
    full_to_full: 'Pieno a pieno',
    miles_per_rental: '{mileage} miglia gratuite per noleggio',
    km_per_rental: '{mileage} km gratuiti per noleggio',
    unlimited_mileage: 'Chilometraggio illimitato',
    unlimited_mileage_km: 'Km illimitati',
    non_amendable: 'Non modificabile',
    non_refundable: 'Non rimborsabile',
    free_cancellation_until: 'Cancellazione gratuita fino a',
    basic_free_cancellation: 'Cancellazione gratuita fino a 48 ore prima dell’orario di inizio',
    cancellation_in_line_with: 'Cancellazione secondo',
    tcs: 'Termini e condizioni',
    free_extras_on_collection: 'Due extra gratuiti al ritiro',
    glass_and_tyres_covered: 'Vetri e pneumatici coperti',
    number_of_passengers: 'Numero di passeggeri',
    number_of_bags: 'Numero di bagagli',
    fuel_type: 'Tipo di carburante',
    co2: 'CO2',
    aircon: 'Aria condizionata',
    transmission: 'Trasmissione',
    book_type: 'Prenota {type}',
    debit_card_deposit: 'Carta di debito accettata per i depositi',
    fast_track_included: 'Fast Track incluso',
    view_all: 'Visualizza tutto',
};
